// src/aws-exports.js
const awsmobile = {
  aws_project_region: "us-east-2",
  aws_cognito_region: "us-east-2",

  aws_user_pools_id: "us-east-2_GF6o0Ayyc",
  aws_user_pools_web_client_id: "7v2bab3fpg286uibh1b42k0ma2",

  oauth: {
    // ⚠️ 这里不要带 https://
    domain: "us-east-2gf6o0ayyc.auth.us-east-2.amazoncognito.com",

    scope: ["phone", "email", "openid", "profile"],

    // 登录/注册成功后 Cognito 跳回你的网站（你 PPT 里的 /register）
    redirectSignIn: "http://3.138.76.93/register",
    redirectSignOut: "http://3.138.76.93/register",

    // Hosted UI 推荐用 code 模式
    responseType: "code",
  },
};

export default awsmobile;
